


import ScrollableContainerComponent from '@/components/shared-components/scrollable-container/scrollable-container.component';
export default ScrollableContainerComponent;



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared-components/scrollable-container/scrollable-container.vue